import {
    Box,
    Button,
    Flex,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import React from 'react'
import ContactUsHeader from './partials/contact-us-header'
// import PhoneContainer from './partials/phoneContainer'
import {FormattedMessage} from 'react-intl'
import {CheckIcon} from '../../components/icons'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {useGetPageByType} from '../../custom-api/hooks/use-get-page-by-type'
import routingObject from '../../utils/static-routes'
import SanitizedHtml from '../../components/html-sanitizer'

const ContactUsConfirmation = () => {
    const styles = useMultiStyleConfig('ContactUs')
    const navigate = useNavigation()
    const handleNavigate = () => {
        navigate(routingObject.CONTACT_US_PATH)
    }
    const {data: contentstackData} = useGetPageByType('contact_us')

    return (
        <Flex {...styles.container} layerStyle={'page'}>
            <ContactUsHeader />
            <SanitizedHtml as="div" html={contentstackData?.top_section} />
            <Flex {...styles.mainContainer}>
                <Flex {...styles.confirmationContainer}>
                    <Flex {...styles.confirmationInnerContainer}>
                        <Box {...styles.messageIconTitle}>
                            <CheckIcon {...styles.confirmIcon} />
                            <Text {...styles.messageTitle}>
                                <FormattedMessage
                                    id="contact_us.confirmation_title"
                                    defaultMessage="Thank you!"
                                />
                            </Text>
                        </Box>
                        <Text {...styles.confirmationText}>
                            <FormattedMessage
                                id="contact_us.confirmation_description"
                                defaultMessage="Your message has been sent. We will get back to you shortly."
                            />
                        </Text>
                    </Flex>
                    <Button variant={'secondary'} onClick={handleNavigate}>
                        <Text {...styles.confirmationButtonText}>
                            <FormattedMessage
                                id="contact_us.confirmation_contact_us_again"
                                defaultMessage="Contact us again"
                            />
                        </Text>
                    </Button>
                </Flex>
                <SanitizedHtml as="div" html={contentstackData?.right_section} />
            </Flex>
            <SanitizedHtml as="div" html={contentstackData?.bottom_section} />
        </Flex>
    )
}

export default ContactUsConfirmation
